import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { g as getOverlay } from './overlay.js';

const prismMenuItemCss = ":where([prism-icon],.prism-icon){--size:1.5rem;--mask-image:url(\"../assets/icons/md/star.svg\");display:inline-block;width:var(--size);height:var(--size);background-color:currentcolor;mask-image:var(--mask-image);-webkit-mask-image:var(--mask-image);mask-repeat:no-repeat;-webkit-mask-repeat:no-repeat;mask-size:contain;-webkit-mask-size:contain;mask-position:center;-webkit-mask-position:center}[prism-icon-size=\"sm\"],.prism-icon-sm{--size:1.125rem}[prism-icon-size=\"lg\"],.prism-icon-lg{--size:2.5rem}[prism-icon=\"chevron_right\"],[prism-icon-family=\"md\"] [prism-icon=\"chevron_right\"],[prism-icon-family=\"md\"][prism-icon=\"chevron_right\"]{--mask-image:url(\"data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M10%206%208.59%207.41%2013.17%2012l-4.58%204.59L10%2018l6-6-6-6z%22%2F%3E%3C%2Fsvg%3E\");mask-image:var(--mask-image);-webkit-mask-image:var(--mask-image)}.pwc-menu-item{display:flex;position:relative;padding:var(--prism-spacing-global-medium) var(--prism-spacing-global-2xm);cursor:pointer;user-select:none;-webkit-user-select:none;white-space:nowrap}.pwc-menu-item.pwc-disabled{pointer-events:none;cursor:default;user-select:none;color:var(--prism-color-theme-disabled-contrast)}.pwc-menu-item.pwc-active:not(.pwc-disabled),.pwc-menu-item:hover:not(.pwc-disabled){background-color:var(--prism-color-theme-window-film-hover)}.pwc-menu-item:active:not(.pwc-disabled){background-color:var(--prism-color-theme-window-film-pressed)}.pwc-menu-item:focus:not(.pwc-disabled){background-color:var(--prism-color-theme-window-film-focused)}.pwc-menu-item:focus-visible:not(.pwc-disabled){background-color:var(--prism-color-theme-window-film-focused);outline:none}.pwc-text-container{flex:1;text-align:start;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.pwc-start{margin-right:5px;height:22.4px}.pwc-end{margin-left:5px;height:22.4px}:host([selected]) .pwc-menu-item{background-color:var(--prism-color-theme-accent-primary);color:var(--prism-color-theme-accent-primary-contrast)}";
const PrismMenuItemStyle0 = prismMenuItemCss;

const sharedCss = ".prism-headline-mega{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20);text-transform:uppercase;}.prism-headline-mega-inlined{font-size:var(--prism-typography-global-type-scale-step8);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smallest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-90);text-transform:uppercase;}.prism-headline-2xl{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-2xl-inlined{font-size:var(--prism-typography-global-type-scale-step7);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-smaller);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-xl{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-xl-inlined{font-size:var(--prism-typography-global-type-scale-step6);font-family:var(--prism-typography-global-font-family-heading-inline);font-weight:var(--prism-typography-global-font-weight-regular);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:var(--prism-typography-global-line-height-small);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100);text-transform:uppercase;}.prism-headline-large{font-size:var(--prism-typography-global-type-scale-step5);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30)}.prism-headline-medium{font-size:var(--prism-typography-global-type-scale-step4);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-30);text-transform:uppercase;}.prism-headline-small{font-size:var(--prism-typography-global-type-scale-step3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-headline-xs{font-size:var(--prism-typography-global-type-scale-step2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-subtitle-1{font-size:var(--prism-typography-global-type-scale-step1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-20)}.prism-subtitle-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-1,body{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-large);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-body-2{font-size:var(--prism-typography-global-type-scale-step0);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-button,button{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-100)}.prism-caption,caption,figcaption{font-size:var(--prism-typography-global-type-scale-step-1);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-regular);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-40)}.prism-overline{font-size:var(--prism-typography-global-type-scale-step-2);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-regular);line-height:var(--prism-typography-global-line-height-larger);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.prism-microlabel{font-size:var(--prism-typography-global-type-scale-step-3);font-family:var(--prism-typography-global-font-family-default);font-weight:var(--prism-typography-global-font-weight-bold);line-height:var(--prism-typography-global-line-height-largest);letter-spacing:var(--prism-typography-global-letter-spacing-spacing-120);text-transform:uppercase;}.pwc-none{display:none}.pwc-visually-hidden{border:0;height:0;margin:0;padding:0;outline:0;overflow:hidden;position:absolute;white-space:nowrap;width:1px;appearance:none}.pwc-input-label{position:absolute;left:0;top:50%;transform:translateY(-50%);transition:0.1s ease-out;transform-origin:left top;pointer-events:none}.pwc-input{outline:none;background-color:transparent;color:var(--prism-color-theme-ink);padding:var(--prism-spacing-global-small) 0;width:100%}";
const PrismMenuItemStyle1 = sharedCss;

const PrismMenuItem$1 = /*@__PURE__*/ proxyCustomElement(class PrismMenuItem extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.itemSelected = createEvent(this, "itemSelected", 7);
        this.clickListener = this.handleClick.bind(this);
        this.keyDownListener = this.handleKeyDown.bind(this);
        this.value = undefined;
        this.disabled = false;
        this.active = undefined;
        this.selected = undefined;
        this.selectMenuItem = false;
        this.submenu = undefined;
        this.iconEnd = undefined;
        this.iconStart = undefined;
    }
    /**
     * Watcher for the 'active' property.
     * If false, removes the active property from all submenu items and sets nested menu visibility to false.
     */
    watchValue(value) {
        if (!value && this.nestedMenu) {
            const subMenuItems = this.nestedMenu.querySelectorAll('prism-menu-item[active]');
            subMenuItems.forEach((item) => {
                item.removeAttribute('active');
            });
            this.nestedMenu.visible = false;
        }
        else {
            this.deactivateSiblings(false);
        }
    }
    /**
     * Listens for a click event on the menu item and emits the `itemSelected` event with the value of the menu item.
     * The event is only emitted if the button is not disabled and the menu item does not have a submenu.
     */
    handleClick() {
        if (!this.disabled && !this.submenu) {
            this.itemSelected.emit(this.value);
        }
        else if (!this.disabled && this.submenu) {
            this.handleMouseOver();
        }
    }
    /**
     * Handles the keydown event for the specified element.
     */
    handleKeyDown(event) {
        let eventHandled = true;
        switch (event.key) {
            case 'ArrowRight':
                this.handleArrowRight();
                break;
            case 'ArrowLeft':
                this.handleArrowLeft();
                break;
            case 'Enter':
                this.hostElement.click();
                break;
            default:
                eventHandled = false;
        }
        if (eventHandled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /**
     * Removes the active property from menu items(other than the hovered one) of currently focused menu.
     */
    deactivateSiblings(deactivateAll) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const parent = this.hostElement.parentElement;
        const menuItems = [...parent.querySelectorAll('prism-menu-item[active]')];
        if (deactivateAll) {
            menuItems.forEach((item) => item.removeAttribute('active'));
        }
        else {
            const menuItemsWithoutHost = menuItems.filter((item) => item !== this.hostElement);
            menuItemsWithoutHost.forEach((item) => item.removeAttribute('active'));
        }
    }
    /**
     * Handles the mouseover event on the menu item.
     * Sets the active property on the hovered menu item.
     */
    handleMouseOver() {
        this.active = true;
        this.openSubmenu();
    }
    /**
     * Opens the submenu by setting the visibility of the nested menu to true.
     */
    openSubmenu() {
        if (this.submenu) {
            this.nestedMenu = this.getNestedMenu();
            this.nestedMenu.visible = true;
        }
    }
    /**
     * Component lifecycle events. Checks if the menu item has icons.
     */
    componentWillLoad() {
        this.iconStart = !!this.hostElement.querySelector('[slot="icon-start"]');
        this.iconEnd = !!this.hostElement.querySelector('[slot="icon-end"]');
    }
    /**
     * Lifecycle method called when the component is connected to the DOM.
     * Adds a keydown and click event listeners to the component.
     */
    connectedCallback() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const parent = this.hostElement.parentElement;
        if (parent.visible) {
            this.hostElement.addEventListener('keydown', this.keyDownListener);
            this.hostElement.addEventListener('click', this.clickListener);
        }
        if (this.submenu) {
            // Check if a submenu exists
            this.getNestedMenu();
        }
    }
    /**
     * Lifecycle method called when the component is disconnected from the DOM.
     * Removes the keydown and click event listeners from the component.
     */
    disconnectedCallback() {
        this.hostElement.removeEventListener('keydown', this.keyDownListener);
        this.hostElement.removeEventListener('click', this.clickListener);
    }
    render() {
        var _a;
        return (h(Host, { key: '3edb1aad0759efde118cbc17ff49a73d8fce5c26' }, h("div", { key: '31b6cb494b530fa09de442bf97fe0721265f7401', role: this.selectMenuItem ? 'menuitemradio' : 'menuitem', "aria-haspopup": this.submenu ? 'true' : undefined, "aria-expanded": this.submenu ? `${(_a = this.nestedMenu) === null || _a === void 0 ? void 0 : _a.visible}` : undefined, "aria-disabled": `${this.disabled}`, "aria-checked": this.selectMenuItem ? `${this.selected}` : undefined, tabindex: "-1", class: `pwc-menu-item ${this.disabled ? 'pwc-disabled' : ''} ${this.active ? 'pwc-active' : ''}`, onMouseOver: () => this.handleMouseOver() }, h("div", { key: '0c33cf05b0250f10e8ec7a8a968bc1fa8e86b9c3', class: this.iconStart ? 'pwc-start' : 'pwc-none' }, h("slot", { key: '57f85f49f770a4835987edb7b3bbfd5fd26a3fb3', name: "icon-start" })), h("div", { key: 'ef5b80db98f6ca2ebb50e2a9104428dea53d9aa0', class: "pwc-text-container" }, h("slot", { key: '8ffe94ca8bb01d35a72b7fff54aa51f260aba2df' })), h("div", { key: '8e7e7154a36ed556065e46cae3bb2f6205503692', class: this.iconEnd ? 'pwc-end' : 'pwc-none' }, h("slot", { key: '4f4dc3e88e246cc7e921da33e0088b91065b9e83', name: "icon-end" })), h("div", { key: '509e61c3a97ac1598897b9489c59e7dcad32fc30', class: this.submenu ? 'pwc-end' : 'pwc-none' }, h("span", { key: 'c16c83222f1212b9b1816ccc303c2504b9c01c01', "prism-icon": "chevron_right" })))));
    }
    /**
     * Handles the "ArrowRight" key press event.
     *
     * If a submenu is available, it triggers the mouse over event handler to
     * display the submenu and sets focus to the first item in the nested menu.
     */
    handleArrowRight() {
        if (this.submenu) {
            this.handleMouseOver();
            const focusFirstMenuItem = () => {
                this.getFirstNestedMenuItem().focus();
            };
            requestAnimationFrame(focusFirstMenuItem);
        }
    }
    /**
     * Handles the "ArrowLeft" key press event.
     *
     * If the parent menu has a submenu, it hides the submenu, deactivates sibling
     * menu items, and sets focus to the last active menu item in the document.
     */
    handleArrowLeft() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const parentMenu = this.hostElement.parentElement;
        if (parentMenu.submenu) {
            parentMenu.visible = false;
            this.deactivateSiblings(true);
            const menuItems = [...document.querySelectorAll('prism-menu-item[active]')];
            menuItems[menuItems.length - 1].focus();
        }
    }
    /**
     * Retrieves the first menu item from a nested menu.
     *
     * This function checks if the menu base element, identified by the `submenu` ID,
     * is present within a specific overlay. If found, it fetches and returns the
     * first menu item from this menu base. If not found, it fetches and returns the
     * first menu item from another nested menu element.
     *
     * @returns {HTMLElement} The first menu item element from either the menu base or the nested menu.
     */
    getFirstNestedMenuItem() {
        const overlay = getOverlay();
        const menuBase = overlay.querySelector(`#${this.submenu}-menu-base`);
        if (menuBase) {
            const menuItems = [...menuBase.querySelectorAll('prism-menu-item')];
            return menuItems[0].shadowRoot.querySelector('.pwc-menu-item');
        }
        const menuItems = [...this.nestedMenu.querySelectorAll('prism-menu-item')];
        return menuItems[0].shadowRoot.querySelector('.pwc-menu-item');
    }
    /**
     * Retrieves the nested menu.
     *
     * This function checks if the prism-menu-base nested menu element
     * is present outside of the shadowRoot. If found, it fetches and returns the
     * nested menu. If not found, it fetches and returns the prism-menu nested menu element.
     *
     * @returns {HTMLPrismMenuElement} The nested menu element.
     */
    getNestedMenu() {
        const nestedMenuMenuBase = document.querySelector(`#${this.submenu}-menu-base`);
        if (nestedMenuMenuBase) {
            return nestedMenuMenuBase;
        }
        const nestedMenu = document.querySelector(`#${this.submenu}`);
        if (nestedMenu) {
            return nestedMenu;
        }
        // eslint-disable-next-line no-console
        console.error(`[prism-menu] Could not find the submenu with id="${this.submenu}"`);
    }
    static get delegatesFocus() { return true; }
    get hostElement() { return this; }
    static get watchers() { return {
        "active": ["watchValue"]
    }; }
    static get style() { return PrismMenuItemStyle0 + PrismMenuItemStyle1; }
}, [17, "prism-menu-item", {
        "value": [1025],
        "disabled": [4],
        "active": [1540],
        "selected": [1540],
        "selectMenuItem": [4, "select-menu-item"],
        "submenu": [1],
        "iconEnd": [32],
        "iconStart": [32]
    }, undefined, {
        "active": ["watchValue"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["prism-menu-item"];
    components.forEach(tagName => { switch (tagName) {
        case "prism-menu-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PrismMenuItem$1);
            }
            break;
    } });
}

const PrismMenuItem = PrismMenuItem$1;
const defineCustomElement = defineCustomElement$1;

export { PrismMenuItem, defineCustomElement };

